export default __webpack_public_path__ + "static/media/ci_gems.676ffbf2.png";